export const container = ({ isMoving, transitionDuration }) => ({
    width: '100%',
    marginTop: '3.125rem',
    height: '70%',
    display: 'none',

    transform: isMoving ? 'translateY(-20px)' : 'translateY(0px)',
    transition: `cubic-bezier(0.4, 0.0, 0.2, 1) transform ${transitionDuration}s`,
    willChange: 'transform',

    tabletLarge: {
        display: 'block',
        width: '24.275rem',
    },

    desktop: {
        width: '42.875rem',
    },
});

export const shiftContainer = () => ({
    width: '100%',
    maxWidth: '42.875rem',
    marginRight: '11.625rem',

    '@media(max-width: 1440px)': {
        marginRight: 0,
    },
});
